import { Input } from '@ui/themed';
import { t } from 'i18next';
import type { I18nPrefix } from '../../../i18n/prefix';
import type { CredentialFieldConfig } from '../constants';

const CREDENTIAL_I18N = 'features:platform.components.credential' satisfies I18nPrefix;

export function CredentialField({
  config,
  value,
  onChange,
  hasStoredValue,
  error,
}: {
  config: CredentialFieldConfig;
  value: string;
  onChange: (value: string) => void;
  hasStoredValue: boolean;
  error?: string;
}) {
  const label = t(config.labelKey);
  const displayLabel = t(
    hasStoredValue ? `${CREDENTIAL_I18N}.update` : `${CREDENTIAL_I18N}.enter`,
    { label },
  );
  const placeholder = hasStoredValue
    ? t(`${CREDENTIAL_I18N}.masked_placeholder`)
    : t(config.placeholderKey);

  return (
    <Input
      name={config.key}
      type={config.type ?? 'text'}
      label={displayLabel}
      placeholder={placeholder}
      value={value}
      onChange={onChange}
      error={error}
      autoComplete="new-password"
    />
  );
}
